import {FC, ReactNode, useCallback, useState} from 'react';
import * as Styles from './controlButton.styles';
import {Tooltip} from '../../components/tooltip';

interface ControlButtonProps {
  round?: boolean;
  children: ReactNode;
  tooltipLabel?: string;
  ariaLabel: string;
  ariaPressed?: boolean;
  shortcut?: string;
  onClick: () => void;
  full?: boolean;
}

export const ControlButton: FC<ControlButtonProps> = ({
  children,
  ariaLabel,
  ariaPressed,
  tooltipLabel,
  round = true,
  full = false,
  onClick,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleHover = useCallback(
    (isOver: boolean) => {
      // Only show the tooltip if we were provided a label.
      if (!tooltipLabel) return;

      setIsHovered(isOver);
    },
    [tooltipLabel]
  );

  return (
    <Styles.Container>
      <Styles.ControlButton
        aria-label={ariaLabel}
        aria-pressed={ariaPressed}
        type="button"
        role="button"
        round={round}
        full={full}
        onClick={onClick}
        onMouseEnter={() => handleHover(true)}
        onMouseLeave={() => handleHover(false)}
        onFocus={() => handleHover(true)}
        onBlur={() => handleHover(false)}
      >
        {children}
      </Styles.ControlButton>
      {tooltipLabel && (
        <Styles.TooltipContainer data-testid="tooltip-container">
          <Tooltip label={tooltipLabel} visible={isHovered} type="context" />
        </Styles.TooltipContainer>
      )}
    </Styles.Container>
  );
};
